/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'

import { Container } from '../Container'
import MediaMatch from '../MediaMatch'
import ProfileModal from '../ProfileModal'

import { Overlay } from '../ProfileModal/styles'
import MenuMobile from '../MenuMobile'
import * as S from './styles'

import IconMenuMobile from '../../assets/icons/icon-menu-mobile.svg'

import AvatarDefault from '../../assets/img/avatar-default.svg'

import { UserContext } from '../../contexts/UserContext'

const Header = (onlyLogo) => {
  const { user, getUserData } = useContext(UserContext)

  const [showMenu, setShowMenu] = useState(false)

  const openMenu = () => {
    setShowMenu((prev) => !prev)
  }

  useEffect(() => {
    getUserData()
  }, [])

  if (!onlyLogo) {
    return (
      <S.Wrapper onlyLogo={onlyLogo}>
        <Overlay />
        <Container>
          <S.HColumsn>
            <S.HColumn>
              <Link to="/" passHref>
                <a>
                  <S.Logo
                    src={process.env.REACT_APP_URL_LOGO}
                    alt="Gimba"
                    role="image"
                  />
                </a>
              </Link>
            </S.HColumn>
          </S.HColumsn>
        </Container>
      </S.Wrapper>
    )
  }

  if (onlyLogo) {
    return (
      <S.Wrapper onlyLogo={onlyLogo}>
        <MenuMobile showMenu={showMenu} setShowMenu={setShowMenu}></MenuMobile>
        <Overlay />
        <S.HColumsn>
          <Container>
            <S.HColumsn className="new-header">
              <S.HColumn>
                <MediaMatch lessThan="large">
                  <S.MenuMobileIcon
                    onClick={(e) => {
                      e.preventDefault()
                      openMenu()
                    }}
                  >
                    <a>
                      <img
                        src={IconMenuMobile}
                        alt=""
                        className="menu-mobile-icon"
                      />
                    </a>
                  </S.MenuMobileIcon>
                </MediaMatch>

                <a href={process.env.REACT_APP_URL_MAIN}>
                  <S.Logo
                    src={process.env.REACT_APP_URL_LOGO}
                    alt="Gimba"
                    role="image"
                  />
                </a>
              </S.HColumn>
              <S.HColumn>
                <S.HeaderNavigationItem className="header-navigation-item no-mobile js-toggle-modal-profile account">
                  <Link to="/">
                    <S.HeaderNavigationItemLink className="header-navigation-item-link">
                      <S.NavigationItemLinksIcons className="header-navigation-item-link-icons">
                        <div className="profile-img">
                          <img
                            src={AvatarDefault}
                            alt="foto de perfil do usuário"
                          />
                        </div>
                      </S.NavigationItemLinksIcons>
                      <p>
                        Olá, <strong>{user.apelido ?? user.contato}</strong>{' '}
                      </p>
                    </S.HeaderNavigationItemLink>
                  </Link>

                  <ProfileModal />
                </S.HeaderNavigationItem>
              </S.HColumn>
            </S.HColumsn>
          </Container>
        </S.HColumsn>
      </S.Wrapper>
    )
  }
}

export default Header
